module.exports = __webpack_public_path__ + "img/template.c02d1333.svg";